import React, { useEffect, useState } from 'react';
import { SignIn, SignUp } from '@clerk/clerk-react';
import { consumeSessionExpiredFlag } from '../services/api';

const INTENDED_TIER_KEY = 'sigmacore_intended_tier';

/**
 * Authentication view, now backed entirely by Clerk's prebuilt
 * <SignIn/> / <SignUp/> components. No router is used — the parent App
 * toggles between "signed out" and "signed in" based on Clerk's
 * isSignedIn, so these components stay mounted only while logged out.
 *
 * Marketing-site handoff: the pricing page links here with ?plan=<tier>.
 * We stash that tier in localStorage on mount so the post-signup
 * profile-completion screen (SignupComplete) can read it after Clerk's
 * own redirect flow drops the query string.
 */
export default function AuthPage({ initialMode = 'signIn' }) {
  const [mode, setMode] = useState(initialMode); // 'signIn' | 'signUp'

  // One-shot: was the user bounced here because their session expired?
  // Consumed on read so a refresh doesn't keep the banner stuck up.
  const [sessionExpired] = useState(() => consumeSessionExpiredFlag());

  // Capture ?plan=<tier> once on mount for the post-signup handoff.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const plan = params.get('plan');
    if (plan) {
      localStorage.setItem(INTENDED_TIER_KEY, plan);
    }
    // If we landed on a signup link, default to the sign-up tab.
    if (params.get('mode') === 'signUp') {
      setMode('signUp');
    }
  }, []);

  const isRegister = mode === 'signUp';

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>SigmaCore.ai</h1>

        {sessionExpired && !isRegister && (
          <div className="auth-info" role="status">
            Your session expired. Please sign in again.
          </div>
        )}

        {isRegister ? (
          <SignUp routing="hash" signInUrl="#/sign-in" />
        ) : (
          <SignIn routing="hash" signUpUrl="#/sign-up" />
        )}

        <div className="auth-switch">
          {isRegister ? (
            <>
              Already have an account?{' '}
              <button type="button" className="link-btn" onClick={() => setMode('signIn')}>
                Sign in
              </button>
            </>
          ) : (
            <>
              New here?{' '}
              <button type="button" className="link-btn" onClick={() => setMode('signUp')}>
                Create an account
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
